


import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomTable from '../../../Components/CustomTable/CustomTable';
// selectedRows, checkboxNotRequired
const ProductRelatedNew = ({ handleShow, setdeleteShow, deleteShow, allListProducts, setAllListProducts, relatedListProducts, selectedRelatedIds, setSelectedRelatedIds }) => {

  // const [allListProducts,setAllListProducts]=useState({})


  //   const[selectedRelatedIds,setSelectedRelatedIds]=useState([]);


  const columns =
    [
      {
        Header: "#",
        CustomDesign: (cellProps) => {
          return <>
            <input type="checkbox" className="productCheckBox form-check-input"
              checked={selectedRelatedIds?.includes(cellProps?.id)}
              onChange={(e) => {
                setSelectedRelatedIds(prev => (selectedRelatedIds?.includes(cellProps?.id) ? prev?.filter(it => it !== cellProps?.id) : [...prev, cellProps?.id]))
              }}
            />
          </>;
        },
      },
      {
        Header: "Product name",
        fieldName: 'productTitle',
        CustomDesign: (cellProps) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-2">
                <div className="avatar-sm bg-light rounded p-1 d-flex justify-content-center">
                  <img
                    src={cellProps?.productListImageViews?.[0]?.productListImage?.url || cellProps?.ProductImageColourCombinations?.[0]?.image?.[0]?.preview}
                    alt=""
                    className="img-fluid d-block avatar-xs mt-1"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <Link
                    to={`/product-edit/${cellProps?.id}`}
                    className="d-block text-reset"
                  >
                    {" "}
                    {cellProps?.productTitle}
                  </Link>
                </h5>
                <p className="text-muted mb-0">
                  Category :{" "}
                  <span className="fw-medium">

                    {cellProps?.ProductCategoryCombinations?.reduce((elem, current) => `${elem + current?.Category?.name ?? ''},`, '')}
                  </span>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "Stock",

        fieldName: 'productTitle',
        CustomDesign: (cellProps) => cellProps?.ProductSizeColourCombinations?.reduce((acc, cur) => acc + Number(cur?.quantity), 0)
      },
      {
        Header: "Size",
        fieldName: 'productTitle',
        CustomDesign: (cellProps) => {
          return (
            <div className="d-flex" >
              <div >{cellProps?.ProductSizeCombinations?.map((item, index) =>
                <span className="badge py-2 px-2 bg-light rounded-circle text-info fs-13 fw-medium me-1" style={{ width: "30px", height: "30px" }}>{item?.Size?.name}</span>
              )}</div>
            </div>
          )
        }
      }, {
        Header: "Colour",
        fieldName: 'productTitle',
        CustomDesign: (cellProps) => {
          return (
            <>

              <div className="avatar-group">
                {
                  cellProps?.ProductColourCombinations?.map(color =>
                    <div className="avatar-item" style={{ backgroundColor: color?.ProductColour?.hexCode, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <span className="avatar-text"></span>
                    </div>)
                }

              </div>

            </ >
          )
        }
      },
      {
        Header: "Price",

        fieldName: 'sellingPrice'

      },
    ]

  const [page, setPage] = useState(1)
  const [limit, setlimit] = useState(10)
  const [metaData, setMetaData] = useState({});

  useEffect(() => {
    if (relatedListProducts.length > 0) {
      const totalPages = Math.ceil(relatedListProducts.length / limit);
      const currentCount = relatedListProducts.slice(
        (page - 1) * limit,
        page * limit
      ).length;

      setMetaData({
        pageSize: totalPages,
        count: currentCount,
      });
    }
  }, [relatedListProducts, page, limit]);
  console.log('relatedListProducts.length', relatedListProducts.length)
  return (
    <React.Fragment>
      <Row className="g-4 mb-4">
        <Col className="col-sm-auto">
          <div>
            <button className="btn btn-success" id="addproduct-btn" onClick={handleShow}><i className="ri-add-line align-bottom me-1"></i> Add Related Product New</button>
            <span style={{ marginRight: '10px' }}></span>
            <button className="btn btn-primary shadow-lg rounded" id="removeproduct-btn" onClick={() => {

              if (selectedRelatedIds?.length > 0) {

                setdeleteShow(true)
              } else {
                toast.error('Please select any products');
              }
            }}><i className="ri-delete-bin-line align-bottom me-1"></i>Remove Related Product</button>
          </div>

        </Col>
      </Row>
      <div>

        <CustomTable limit={limit} setlimit={setlimit}
          key="Product List"
          metaData={metaData}
          columns={columns} rowsData={relatedListProducts || []} page={page} setPage={setPage}

        />

      </div>
    </React.Fragment>
  );
};

export default ProductRelatedNew;
